"use client";

import { CSSProperties, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useReveal } from "../kit/useReveal";

/**
 * Server-friendly wrapper around the kit's `useReveal`: fade/rise (`qe-rv`) with an optional stagger
 * `delay` (ms → `--d`), or, with `bare`, only the `qe-in` flag so the children run their own animation.
 */
export default function Reveal({ children, className, delay = 0, bare = false }: { children: ReactNode; className?: string; delay?: number; bare?: boolean }) {
  const [ref, on] = useReveal<HTMLDivElement>();
  return (
    <div ref={ref} className={cn(!bare && "qe-rv", on && "qe-in", className)} style={{ "--d": `${delay}ms` } as CSSProperties}>
      {children}
    </div>
  );
}
